import { Dispatch } from "redux";
import {
  ADD_SECTION,
  ADD_SECTION_LIST,
  AppActions,
  DROP_SECTION,
  EDIT_SECTION,
  MOVE_SECTION,
  REMOVE_ALL_SECTIONS,
  REMOVE_SECTION,
  REMOVE_SECTION_LIST_BY_FORM_ID,
  SET_SECTION,
} from "../types/actions";
import { AppState } from "../reducers/rootReducer";
import { uuid } from "uuidv4";
import { Section } from "../models/sectionModel";
import sectionService from "../services/sectionService";

export const addSection = (section: Section): AppActions => ({
  type: ADD_SECTION,
  section,
});

export const addSections = (sections: Section[]): AppActions => ({
  type: ADD_SECTION_LIST,
  sections,
});

export const editSection = (section: Section): AppActions => ({
  type: EDIT_SECTION,
  section,
});

export const removeSection = (id: String): AppActions => ({
  type: REMOVE_SECTION,
  id,
});

export const removeSectionListByFormId = (formId: String): AppActions => ({
  type: REMOVE_SECTION_LIST_BY_FORM_ID,
  formId,
});

export const setSection = (sections: Section[]): AppActions => ({
  type: SET_SECTION,
  sections,
});

export const moveSection = (
  sectionDrag: Section,
  sectionDrop: Section
): AppActions => ({
  type: MOVE_SECTION,
  sectionDrag,
  sectionDrop,
});

export const dropSection = (
  section: Section,
  newRowId: String
): AppActions => ({
  type: DROP_SECTION,
  section,
  newRowId,
});

export const removeAllSections = (sections: Section[]): AppActions => ({
  type: REMOVE_ALL_SECTIONS,
  sections,
});

// start adding row to redux store

export const startAddSection = (sectionData: {
  rowId: String;
  formId: String;
  sortKey: number;
  tempHiglight: boolean;
  sectionRowVerticalAlignment: string;
  sectionRowHorizontalAlignment: string;
  inline: boolean;
  responsiveXs: number;
  responsiveMd: number;
  responsiveLg: number;
  responsiveSm: number;
  cssStyles: [any];
  createdTime: string;
  lastUpdatedTime: string;
}) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const {
      rowId = "1",
      formId = "",
      sortKey = 0,
      tempHiglight = false,
      sectionRowVerticalAlignment = "",
      sectionRowHorizontalAlignment = "",
      inline = false,
      responsiveXs = 1,
      responsiveMd = 1,
      responsiveLg = 1,
      responsiveSm = 1,
      cssStyles = [{}],
      createdTime = "",
      lastUpdatedTime = "",
    } = sectionData;

    const section = {
      rowId,
      formId,
      sortKey,
      tempHiglight,
      sectionRowVerticalAlignment,
      sectionRowHorizontalAlignment,
      inline,
      responsiveXs,
      responsiveMd,
      responsiveLg,
      responsiveSm,
      cssStyles,
      createdTime,
      lastUpdatedTime,
    };
    const id = uuid();

    const { data } = await sectionService.createSection({
      id,
      ...section,
    });

    dispatch(addSection(data.data));
  };
};

export const startEditSection = (section: Section) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    sectionService.updateSection(section);
    dispatch(editSection(section));
  };
};

// start remove section from redux store

export const startRemoveSection = (id: String) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(removeSection(id));
  };
};

// start select all section from redux store

export const startSetSection = (sections: Section[]) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(setSection(sections));
  };
};

export const startMoveSection = (
  sectionDrag: Section,
  sectionDrop: Section
) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(moveSection(sectionDrag, sectionDrop));
    const sections = getState().sectionList;
    sectionService.moveSections(sections);
  };
};

export const startDropSection = (section: Section, newRowId: String) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(dropSection(section, newRowId));
    const sections = getState().sectionList;
    sectionService.moveSections(sections);
  };
};
